import { render, staticRenderFns } from "./Almacenes.vue?vue&type=template&id=e400116c&"
import script from "./Almacenes.vue?vue&type=script&lang=js&"
export * from "./Almacenes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports